import React from 'react';
import ToolLogo from './ToolLogo';
import { stackCategories } from '../data/stack';
import './StackMarquee.css';

const allTools = stackCategories.flatMap((category) => category.tools);
const trackTools = [...allTools, ...allTools];

const StackMarquee = () => (
  <div className="stack-marquee">
    <div className="stack-marquee-track">
      {trackTools.map((tool, i) => (
        <div className="stack-marquee-item" key={`${tool.name}-${i}`} title={tool.name}>
          <div className="stack-marquee-icon">
            <ToolLogo tool={tool} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default StackMarquee;
